import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import styles from './sidebar.module.scss';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface ISideOpenItemList {
	mini?: boolean;
	title?: JSX.Element | string;
	routeList: string[];
	icon: string;
	color?: string;
	children: React.ReactNode; // the list items to show when expanded
}

export const SideOpenItemList = ({ mini = false, title, routeList, icon, color, children }: ISideOpenItemList) => {
	const { entityRoute } = useRoute();
	const isListActive = routeList.includes(entityRoute);
	const [isOpen, setIsOpen] = useState<boolean>(isListActive || localStorage.getItem(`sidebarTab-${title}`) === 'true');
	const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

	const triggerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!isOpen) {
			return;
		}
		updatePos();
		document.addEventListener('scroll', updatePos, true);
		return () => {
			document.removeEventListener('scroll', updatePos, true);
		};
	}, [isOpen]);

	const updatePos = () => {
		console.log('updatePos');
		const r = triggerRef.current?.getBoundingClientRect();
		if (!r) {
			return;
		}
		setPos({ top: r.top, left: r.right - 25 });
	};

	const handleTabClick = () => {
		// save to local storage with the title as key
		localStorage.setItem(`sidebarTab-${title}`, JSON.stringify(!isOpen));
		if (!isOpen) {
			updatePos();
		}
		setIsOpen(!isOpen);
	};
	return (
		<li className={`${styles.sideOpenItemWrapper}`}>
			<div
				className={`${styles.itemWrapper} ${isListActive && isOpen ? styles.activeList : isListActive ? styles.activeList : isOpen ? styles.openListSection : ''}`}
				ref={triggerRef}>
				<div className={`${styles.itemLink}`}>
					<div onClick={handleTabClick} className={`${styles.item}`}>
						{!mini && <span className={styles.itemTitle}>{title}</span>}
						<Icon className={`${styles.icon} ${styles.sectionListIcon}`} isMFP color={color} size="18px">
							{icon}
						</Icon>
					</div>
				</div>
			</div>

			{isOpen &&
				pos &&
				createPortal(
					<div className={`${styles.wrapper} ${styles.flyoutWrapper}`} style={{ top: pos.top, left: pos.left }}>
						<ul className={`${styles.list} ${styles.fullList} ${styles.flyoutList}`} onClick={handleTabClick}>
							{children}
						</ul>
					</div>,
					document.body
				)}
		</li>
	);
};
